module.exports = __webpack_public_path__ + "static/media/cp6in.d7a63762.png";